import { inject, Injectable } from '@angular/core';
import { FacetsFacade } from 'src/app/state/facets/facets.facade';

@Injectable({
  providedIn: 'root',
})
export class FacetsResetResolver {
  private readonly facetsFacade = inject(FacetsFacade);

  resolve() {
    return this.facetsFacade.resetStore();
  }
}
